import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';

interface TestType {
  id: string;
  title: string;
  description: string;
  duration: string;
  icon: string;
  colorClass: string;
}

@Component({
  selector: 'app-placement-test-type',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './placement-test-type.component.html',
  styleUrl: './placement-test-type.component.scss'
})
export class PlacementTestTypeComponent {
  testTypes: TestType[] = [
    {
      id: 'aptitude',
      title: 'Aptitude',
      description: 'Test your numerical reasoning, data interpretation, percentages, profit & loss, time & work, and mathematical problem-solving skills.',
      duration: '30-45 min',
      icon: 'calculate',
      colorClass: 'purple-card'
    },
    {
      id: 'logical',
      title: 'Logical Reasoning',
      description: 'Practice puzzles, pattern recognition, seating arrangements, blood relations, coding-decoding, and logical deduction problems.',
      duration: '25-40 min',
      icon: 'psychology',
      colorClass: 'blue-card'
    },
    {
      id: 'verbal',
      title: 'Verbal Ability',
      description: 'Improve reading comprehension, grammar, vocabulary, synonyms, antonyms, sentence correction, and para jumbles.',
      duration: '20-35 min',
      icon: 'menu_book',
      colorClass: 'teal-card'
    },
    {
      id: 'programming',
      title: 'Programming MCQs',
      description: 'Master object-oriented programming, data structures, algorithms, database management, operating systems, and computer networks.',
      duration: '30-45 min',
      icon: 'code',
      colorClass: 'yellow-card'
    },
    {
      id: 'mixed',
      title: 'Mixed Test',
      description: 'A curated blend of aptitude, logical reasoning, verbal ability, and programming questions with AI-recommended distribution.',
      duration: '45-60 min',
      icon: 'shuffle',
      colorClass: 'orange-card'
    },
    {
      id: 'company',
      title: 'Company-Specific',
      description: 'Tailored mock tests matching the hiring patterns and question styles of specific companies like TCS, Infosys, Wipro, and more.',
      duration: 'Varies',
      icon: 'business',
      colorClass: 'indigo-card'
    },
    {
      id: 'resume',
      title: 'Resume-Based',
      description: 'Upload your resume and get a personalized test based on your skills, experience, and the roles you are targeting.',
      duration: '30-45 min',
      icon: 'description',
      colorClass: 'pink-card'
    }
  ];

  constructor(private router: Router) { }

  goBack() {
    this.router.navigate(['/student-dashboard/placement-prep']);
  }

  startTest(type: TestType) {
    const supportedTypes = ['aptitude', 'logical', 'verbal', 'programming', 'mixed', 'company', 'resume'];
    if (supportedTypes.includes(type.id)) {
      this.router.navigate(['/student-dashboard/placement-test-setup', type.id]);
    }
  }
}
